import React, { useContext, useEffect, useState } from 'react';
import useStickyStyles from '../../styles/sticky/sticky.style';
import clsx from 'clsx';
import { StickyContext } from '../../context/StickyContext';
import useResizeObserver from '@react-hook/resize-observer';
import theme from '../App/theme';
import { useWindowWidth } from '@react-hook/window-size';

interface Props {
    children: React.ReactElement;
    className?: string;
    order: number;
    topOffsetAdjustment?: number;
}

export default function Sticky(props: Props) {
    const { elements, addElement, updateElement } = useContext(StickyContext);
    const [top, setTop] = useState<number>(0);
    const [height, setHeight] = useState<number>(0);
    const nodeRef = React.useRef<HTMLDivElement | null>(null);
    useResizeObserver(nodeRef, (entry) => setHeight(entry.contentRect.height));
    const onlyWidth = useWindowWidth();

    const classes = useStickyStyles();

    useEffect(() => {
        if (!elements.find((element) => element.order === props.order)) {
            setTop(
                addElement({
                    height: height,
                    order: props.order,
                    offsetTop: nodeRef?.current?.offsetTop || 0,
                }),
            );
        } else {
            setTop(
                updateElement(
                    props.order,
                    height,
                    nodeRef?.current?.offsetTop || 0,
                ),
            );
        }
    }, [addElement, elements, height, onlyWidth, props.order, updateElement]);

    return (
        <div
            ref={nodeRef}
            className={clsx(classes.root, props.className)}
            style={{
                top: top + (props?.topOffsetAdjustment || 0),
                zIndex: theme.zIndex.modal + 100 - props.order,
            }}
        >
            {props.children}
        </div>
    );
}
